export default function ({ app, store, redirect }) {
  // @todo redis middleware
  // if (!store.getters['user/GET_IS_MEDICLUB_MEMBER']) {
  //   redirect(app.localePath('/customer/agreements/?redirect'))
  // }
}
